// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .box-restrictions-selector {
  display: inline-block;
}
.presize-root .box-restrictions-selector .ant-select-selector {
  padding-left: 0 !important;
}
.presize-root .box-restrictions-selector .selector-label {
  font-size: 12px;
  cursor: pointer;
  margin-right: 4px;
  color: #66676e;
}
.presize-root .box-restrictions-selector .ant-select-selection-item .box-size-tag {
  display: none;
}
.presize-root .create-box-link {
  display: inline;
}
.presize-root .box-size-tag .anticon {
  margin-right: 4px;
}
.presize-root .box-size-tag.ant-btn-txt-default {
  border-color: transparent;
  background: transparent;
  position: relative;
  left: 0px;
  margin-left: 10px;
}
.presize-root .box-size-tag .ant-btn:disabled {
  border-color: transparent;
}
.presize-root .box-size-tag.ant-btn-txt-default:hover,
.presize-root .box-size-tag.ant-btn-txt-default:focus {
  background-color: #efeff0;
  color: #4d4e50;
}
.presize-root .box-size-container {
  display: flex;
  justify-content: space-between;
}
.presize-root .create-box-option {
  display: flex;
  flex-wrap: nowrap;
  padding: 5px 8px;
}
.presize-root .create-box-option .rds-link {
  font-size: 14px;
  cursor: pointer;
}
/*# sourceMappingURL=BoxRestrictionsSelector.css.map */`, "",{"version":3,"sources":["webpack://./BoxRestrictionsSelector.less","webpack://./src/components/SizingGroup/GroupHeader/BoxRestrictionsSelector/BoxRestrictionsSelector.less"],"names":[],"mappings":"AAAA;EAEE,qBAAA;ACAF;ADFA;EAII,0BAAA;ACCJ;ADLA;EAOI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACCJ;ADXA;EAcM,aAAA;ACAN;ADdA;EAmBE,eAAA;ACFF;ADjBA;EAuBI,iBAAA;ACHJ;ADKE;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;ACHJ;AD3BA;EAiCI,yBAAA;ACHJ;ADKE;;EAEE,yBAAA;EACA,cAAA;ACHJ;ADnCA;EA2CE,aAAA;EACA,8BAAA;ACLF;ADvCA;EAgDE,aAAA;EACA,iBAAA;EACA,gBAAA;ACNF;AD5CA;EAoDI,eAAA;EACA,eAAA;ACLJ;AACA,sDAAsD","sourcesContent":[".presize-root { \n .box-restrictions-selector {\n  display: inline-block;\n  .ant-select-selector {\n    padding-left: 0 !important;\n  }\n  .selector-label {\n    font-size: 12px;\n    cursor: pointer;\n    margin-right: 4px;\n    color: #66676e;\n  }\n  .ant-select-selection-item {\n    .box-size-tag {\n      display: none;\n    }\n  }\n}\n.create-box-link {\n  display: inline;\n}\n.box-size-tag {\n  .anticon {\n    margin-right: 4px;\n  }\n  &.ant-btn-txt-default {\n    border-color: transparent;\n    background: transparent;\n    position: relative;\n    left: 0px;\n    margin-left: 10px;\n  }\n  .ant-btn:disabled {\n    border-color: transparent;\n  }\n  &.ant-btn-txt-default:hover,\n  &.ant-btn-txt-default:focus {\n    background-color: #efeff0;\n    color: #4d4e50;\n  }\n}\n\n.box-size-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.create-box-option {\n  display: flex;\n  flex-wrap: nowrap;\n  padding: 5px 8px;\n  .rds-link {\n    font-size: 14px;\n    cursor: pointer;\n  }\n}\n \n}",".presize-root .box-restrictions-selector {\n  display: inline-block;\n}\n.presize-root .box-restrictions-selector .ant-select-selector {\n  padding-left: 0 !important;\n}\n.presize-root .box-restrictions-selector .selector-label {\n  font-size: 12px;\n  cursor: pointer;\n  margin-right: 4px;\n  color: #66676e;\n}\n.presize-root .box-restrictions-selector .ant-select-selection-item .box-size-tag {\n  display: none;\n}\n.presize-root .create-box-link {\n  display: inline;\n}\n.presize-root .box-size-tag .anticon {\n  margin-right: 4px;\n}\n.presize-root .box-size-tag.ant-btn-txt-default {\n  border-color: transparent;\n  background: transparent;\n  position: relative;\n  left: 0px;\n  margin-left: 10px;\n}\n.presize-root .box-size-tag .ant-btn:disabled {\n  border-color: transparent;\n}\n.presize-root .box-size-tag.ant-btn-txt-default:hover,\n.presize-root .box-size-tag.ant-btn-txt-default:focus {\n  background-color: #efeff0;\n  color: #4d4e50;\n}\n.presize-root .box-size-container {\n  display: flex;\n  justify-content: space-between;\n}\n.presize-root .create-box-option {\n  display: flex;\n  flex-wrap: nowrap;\n  padding: 5px 8px;\n}\n.presize-root .create-box-option .rds-link {\n  font-size: 14px;\n  cursor: pointer;\n}\n/*# sourceMappingURL=BoxRestrictionsSelector.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
